import qs from 'qs'

export const getHomepage = (axios) => {
  const query = qs.stringify(
    {
      populate: [
        'serp',
        'social_sharing',
        'social_sharing.cover_image',
        'homepage_slider',
        'homepage_slider.image',
        'logos',
        'logos.logo',
        'hover_columns',
        'hover_columns.image',
      ],
    },
    {
      encodeValuesOnly: true,
    }
  )

  return axios.get(`/api/gym-homepage?${query.trim()}`)
}
